export default __webpack_public_path__ + "static/media/CCaas.df186c77.svg";